// See reportMain component for base component

import React, { Component } from 'react';

import Scroll from 'react-scroll';

var Element = Scroll.Element;

class Conclusions extends Component {
  render() {
    return (
      <div className='trElement'>
        <Element name='conclusions' className='pt-3'>
          <h2>Conclusions and Key Recommendations </h2>

          <p>
            Designers (both surveyed and interviewed) all recognized the
            importance/power of participatory design as a way to amplify and
            support communities. Before being able to reap the benefits of
            participatory design, the designers have to work through several
            limitations. These are mainly funding, time constraints (especially
            when working in a consultancy position), and accessibility. This of
            course has not prevented the designers from doing their work, but
            many of them mentioned how funding especially is a major inhibitor
            to doing their work to the full extent that they would like to do
            it. However, by persevering through these challenges designers can
            make a long-lasting impact on the communities that they work with.{' '}
          </p>
          <h3>Recommendations</h3>
          <p>
            Based on its efficacy in a variety of workplace settings as a tool
            for social change, it is believed that institutions would benefit
            from continued advocacy of the use of participatory design methods.
            This is particularly important for institutions who emphasize value
            of social good in technology and design. While universities have
            historically had less than ideal relationships with the communities
            that surround them, it is up to the individual researchers and
            designers to rebuild those relationships with communities. By
            acknowledging the limitations of universities, companies and
            government, we can adapt existing methods to best meet the needs of
            communities. Designers who value social change should also be
            encouraged to get to know the communities that represent their
            target users, and to work closely and collaboratively with them.{' '}
          </p>
          <p>
            The Creative Reaction Lab’s Design Equity Field Guide, defines
            design equity as a set of design practices that focus “on a
            community’s culture and needs so they can gain tools to dismantle
            systemic oppression and create a future with equity for all.”. In
            order to promote equitable outcomes through design, institutions
            must invest in the designers working to assess and meet the needs of
            the communities they work with. Our research identified funding as a
            major barrier to the work of Denizen Designers and we strongly
            encourage the institutions they work for to recognize and support
            the value of this research as a part of their institutional mission
            and a means of supporting social change.{' '}
          </p>
          <p>
            Finally, it is also believed that communities would benefit from
            increased exposure to design methods and resources that allow them
            to continue work done in their communities. Rather than creating a
            dependent dynamic, affording communities with the tools to continue
            the work done in their communities can help promote sustainable
            outcomes.{' '}
          </p>
          <h3>Outputs of the Denizen Designer Project</h3>
          <p>
            The findings of the Denizen Designer Project are also being adapted
            and published in a zine, a website, and a conference paper. The zine
            is intended to be used as a tool for community members and designers
            who are interested in incorporating more community-based
            participatory design methods into their work. The zine is intended
            to be used as a guide by showcasing the way design is implemented
            through case studies of community projects and identifying
            participatory design in some of the Denizen Designers’ own projects.{' '}
          </p>
          <p>
            Along with the information discussed in this report, the website
            will display profiles of the interviewed Denizen Designers along
            with their social media information. There will also be pages with
            impactful quotes, resources, and a designer database. Many of the
            Denizen Designers that were interviewed mentioned that they felt
            that there was a lack of awareness of other designers who were doing
            participatory based design. Many of them felt that they were the
            only people thinking about this type of design until they met other
            designers either in the Design Justice Network or in other community
            spaces. The website will attempt to fill that gap by creating a
            database of designers involved in PD or CBPR which will in turn help
            designers find one another and build a stronger overall network.{' '}
          </p>
        </Element>
      </div>
    );
  }
}

export default Conclusions;
